import _ from 'lodash';
import * as types from '../constants/action-types';

const initialState = {
  isFetching: false,
  data: {}
};

export default function attendees (state = initialState, action) {
  switch (action.type) {
  case types.ATTENDEES_REQUEST:
  case types.ATTENDEE_CREATE_REQUEST:
  case types.ATTENDEE_CREATE_INVITE_REQUEST:
  case types.ATTENDEE_UPDATE_REQUEST:
    return _.merge({}, state, {
      isFetching: true
    });

  case types.ATTENDEE_CREATE_FAILURE:
  case types.ATTENDEE_CREATE_INVITE_FAILURE:
  case types.ATTENDEE_UPDATE_FAILURE:
  case types.ATTENDEES_FAILURE:
    return _.merge({}, state, {
      isFetching: false
    });

  case types.ATTENDEE_CREATE_SUCCESS:
  case types.ATTENDEE_UPDATE_SUCCESS: {
    const rsvp = _.get(action, 'payload.result');
    const ssoId = _.get(rsvp, 'sso-id');

    return _.merge({}, state, {
      isFetching: false,
      data: { [ssoId]: rsvp }
    });
  }

  case types.ATTENDEE_CREATE_INVITE_SUCCESS: {
    const existingPending = _.get(state, 'pending', []);
    const newPending = _.get(action, 'payload.emails', []);

    return _.merge({}, state, {
      isFetching: false,
      addedPendingCount: newPending.length,
      pending: _.uniq([...existingPending, ...newPending])
    });
  }

  case types.ATTENDEE_CLEAR_INVITE_COUNT: {
    return {
      ...state,
      addedPendingCount: 0
    };
  }

  case types.ATTENDEES_SUCCESS: {
    const rsvps = _.get(action, 'payload.rsvps');
    const pending = _.get(action, 'payload.pending');

    const data = _.reduce(rsvps, (result, rsvp) => {
      const ssoId = _.get(rsvp, 'sso-id');

      return _.assign(result, { [ssoId]: rsvp });
    }, {});

    return {
      ...state,
      isFetching: false,
      pending,
      data
    };
  }

  default:
    return state;
  }
}
